import React, { Fragment, useEffect, useState } from "react";
import { Card, Typography, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import ScrollbarContainer from "../../../components/ScrollBar/CustomScrollbar";

const MunicipiosTabla = (props) => {
  const { municipios } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [especialidadesFiltradas, setCitasFiltradas] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  useEffect(() => {
    setCitasFiltradas(municipios);
  }, [municipios]);


  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: 5,
        marginBottom: 2,
        p: 0,
        backgroundColor: 'white',
      }}
    >
      <ScrollbarContainer>
        <Table
          sx={{
            backgroundColor: 'white',
          }}
        >
          <TableHead>
            <TableCell
              sx={{
                color: 'primary.textDark',
                fontWeight: 600,
                fontSize: '15px',
              }}
            >
              Nombre
            </TableCell>
            <TableCell
              sx={{
                color: 'primary.textDark',
                fontWeight: 600,
                fontSize: '15px',
              }}
            >
              Fecha de creación
            </TableCell>
          </TableHead>
          <TableBody>
            {especialidadesFiltradas?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((especialidad) => (
              <Fragment key={especialidad.id}>
                <TableRow
                  hover
                  key={especialidad.id}
                >
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {especialidad?.nombre}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {new Date(especialidad?.createdAt).toLocaleDateString()}
                    </Typography>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[40, 80, 120]}
          component='div'
          count={especialidadesFiltradas?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          labelRowsPerPage='Filas por página'
        />
      </ScrollbarContainer>
    </Card >
  );
}

export default MunicipiosTabla;